<template>
  <div
    class="carouselContainer"
  >
    <client-only>
      <carousel
        v-if="pictures"
        ref="_carousel"
        :model-value="activeIndex"
        class="_carousel"
      >
        <slide
          v-for="picture in pictures"
          :key="'slide_' + picture?.id"
        >
          <div class="carousel__item">
            <iframe
              v-if="picture?.value"
              class="img"
              :src="picture?.value"
              frameborder="0"
              allowfullscreen
              allow="fullscreen"
              width="1000"
              height="800"
            />
            <VImg
              v-else
              :src="picture?.url"
            />
          </div>
        </slide>

        <template #addons>
          <navigation />
        </template>
      </carousel>
    </client-only>
    <div
      class="progress"
      :class="{ desktop }"
    >
      <img
        src="~/assets/icons/gallery.png"
        loading="lazy"
      >
      <span>{{ currentSlide }}/{{ pictures?.length }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Navigation } from 'vue3-carousel'

defineProps<{
  pictures?: Array<any>,
  activeIndex?: number,
  desktop?: boolean
}>()

const _carousel: any = ref(null)

const currentSlide = computed(() => {
  return 1 + (_carousel?.value?.data?.currentSlide?.value ?? 0)
})

onMounted(() => {
  /* keyboard navigation */
  document.addEventListener('keydown', function (event) {
    if (event.code === 'ArrowRight') {
      _carousel?.value?.next()
    } else if (event.code === 'ArrowLeft') {
      _carousel?.value?.prev()
    }
  })
})
</script>

<style lang="scss" scoped>
.carouselContainer {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  ._carousel {
    width: 100%;
    height: 100%;
    overflow: hidden;

    .carousel__item {
      position: relative;
      min-height: 200px;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      @media (width <= 768px) {
        height: 250px;
      }

      .v-img {
        max-height: calc(100vh - 100px)
      }
    }

    :deep(.carousel__prev), :deep(.carousel__next) {
      background-color: rgba(255 255 255 / 80%);
      border-radius: 100%;
    }
  }

  .progress {
    background: #1f1f1f;
    opacity: 0.5;
    width: 60px;
    position: absolute;
    border-radius: 15px;
    left: 15px;
    top: 15px;

    &.desktop {
      left: 20px;
      top: 20px;
    }

    span {
      padding-left: 6px;
      color: #fff;
      font-size: 12px;
      font-weight: normal;
    }

    img {
      float: left;
      width: 14px;
      margin-left: 6px;
      margin-top: 6px;
    }
  }
}
</style>
